<div class="modal-content">
  <div class="container-fluid">
    <br /><br /><br /><br />
    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);" routerLink="/management/terminal-config">Terminal Audit</a></li>
              <li class="breadcrumb-item active">View Terminal Audit</li>
            </ol>
          </div>
          <h4 class="page-title">Merchant Management Audit</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->


    <div class="row" id="content" #content>
      <div class="col-12">
        Audit trail for Terminal number: <b>{{terminalNumber}}</b>
        <div class="card-box">
          <ul ngbNav #nav="ngbNav" class="nav nav-tabs" (activeIdChange)="initTable($event)">
            <li [ngbNavItem]="1">
              <a ngbNavLink>Terminal details</a>
              <ng-template ngbNavContent>
                <div class="row">
                  <div class="col-12 mb-2">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0">
                      <thead>
                        <tr>
                          <th style="width:5px;"> Id</th>
                          <th style="width:80px">Changed On </th>
                          <th style="width:120px">Changed By </th>
                          <th style="width:50px">Source </th>
                          <th>Merchant number </th>
                          <th style="width:100px">Terminal config Id </th>
                          <th style="width:150px">Terminal Id </th>
                          <th style="width:50px">Active </th>
                          <th style="width:70px">Manual pan entry </th>
                          <th style="width:50px">Terminal type </th>
                          <th style="width:70px">Product profile </th>
                          <th style="width:70px">Terminal Capability </th>
                          <th style="width:70px">Comms profile</th>
                          <th style="width:70px">Contact less</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let terminal of terminalDetails">
                          <td style="font-size:12px"> {{ terminal.id }} </td>
                          <td style="font-size:12px"> {{ terminal.changedOn | date:'MMMM d, y, h:mm:ss a' }} </td>
                          <td style="font-size:12px"> {{ terminal.changedBy }} </td>
                          <td style="font-size:12px"> {{ terminal.source }} </td>
                          <td style="font-size:12px"> {{ terminal.merchantNumber }} </td>
                          <td style="font-size:12px"> {{ terminal.terminalConfigId }} </td>
                          <td style="font-size:12px"> {{ terminal.terminalId }} </td>
                          <td style="font-size:12px"> {{ terminal.active }} </td>
                          <td style="font-size:12px"> {{ terminal.manualPanEntry }} </td>
                          <td style="font-size:12px"> {{ terminal.terminalType }} </td>
                          <td style="font-size:12px"> {{ terminal.productProfile }} </td>
                          <td style="font-size:12px"> {{ terminal.terminalCapability }} </td>
                          <td style="font-size:12px"> {{ terminal.commsProfile }} </td>
                          <td style="font-size:12px"> {{ terminal.contactLess }} </td>

                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="page-title-box">
                      <div class="page-title-right">
                        <input type="button" value="Print" class="btn btn-success" (click)="print()">
                        &nbsp;
                        <input type="button" value="Export to CSV" class="btn btn-success" (click)="DownloadTerminalDetailsCsv()">
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="2">
              <a ngbNavLink>Terminal interaction details</a>
              <ng-template ngbNavContent>
                <div class="row">
                  <div class="col-12 mb-2">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0">
                      <thead>
                        <tr>
                          <th style="width:5px;"> Id</th>
                          <th> Changed On </th>
                          <th style="width:120px"> Changed By </th>
                          <th style="width:40px"> Source </th>
                          <th> Terminal Id </th>
                          <th> Banking window </th>
                          <th> Parameter download day</th>
                          <th> Parameter download window </th>
                          <th> Interaction type </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let interaction of terminalInteractions">
                          <td style="font-size:12px"> {{ interaction.id }} </td>
                          <td style="font-size:12px"> {{ interaction.changedOn | date:'MMMM d, y, h:mm:ss a' }} </td>
                          <td style="font-size:12px"> {{ interaction.changedBy }} </td>
                          <td style="font-size:12px"> {{ interaction.source }} </td>
                          <td style="font-size:12px"> {{ interaction.terminalId }} </td>
                          <td style="font-size:12px"> {{ interaction.bankingWindow}} </td>
                          <td style="font-size:12px"> {{ interaction.parameterDownloadDay }} </td>
                          <td style="font-size:12px"> {{ interaction.parameterDownloadWindow }} </td>
                          <td style="font-size:12px"> {{ interaction.interactionType }} </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="page-title-box">
                      <div class="page-title-right">
                        <input type="button" value="Print" class="btn btn-success" (click)="print()">
                        &nbsp;
                        <input type="button" value="Export to CSV" class="btn btn-success" (click)="DownloadTerminalInteractionDetailsCsv()">
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="3">
              <a ngbNavLink>Terminal group and custom parameters</a>
              <ng-template ngbNavContent>
                <div class="row">
                  <div class="col-12 mb-2">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0">
                      <thead>
                        <tr>
                          <th style="width:5px;"> Id</th>
                          <th> Changed On </th>
                          <th style="width:120px"> Changed By </th>
                          <th style="width:40px"> Source </th>
                          <th> Terminal Id </th>
                          <th> Group </th>
                          <th> Tag</th>
                          <th> Value on Server </th>
                          <th> Field Id </th>
                          <th> Last Updated</th>
                          <th> Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let interaction of terminalGroupsAndCustomParameters">
                          <td style="font-size:12px"> {{ interaction.id }} </td>
                          <td style="font-size:12px"> {{ interaction.changedOn | date:'MMMM d, y, h:mm:ss a' }} </td>
                          <td style="font-size:12px"> {{ interaction.changedBy }} </td>
                          <td style="font-size:12px"> {{ interaction.source }} </td>
                          <td style="font-size:12px"> {{ interaction.terminalId }} </td>
                          <td style="font-size:12px"> {{ interaction.groupName}} </td>
                          <td style="font-size:12px"> {{ interaction.tag }} </td>
                          <td style="font-size:12px"> {{ interaction.valueOnServer }} </td>
                          <td style="font-size:12px"> {{ interaction.fileId }} </td>
                          <td style="font-size:12px"> {{ interaction.lastUpdated }} </td>
                          <td style="font-size:12px"> {{ interaction.action }} </td>
                          
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="page-title-box">
                      <div class="page-title-right">
                        <input type="button" value="Print" class="btn btn-success" (click)="print()">
                        &nbsp;
                        <input type="button" value="Export to CSV" class="btn btn-success" (click)="DownloadTerminalInteractionDetailsCsv()">
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </li>
          </ul>

          <div [ngbNavOutlet]="nav" class="tab-pane">
          </div>


        </div>
      </div>
    </div>
  </div>
</div>
